/**
 * EQ - Égaliseur 3 bandes (Low, Mid, High)
 * Utilise Tone.EQ3 pour le traitement
 */

import * as Tone from 'tone';

export class EQ {
    constructor() {
        // EQ 3 bandes avec fréquences de coupure
        this.eq = new Tone.EQ3({
            low: 0,
            mid: 0,
            high: 0,
            lowFrequency: 250,    // Fréquence de coupure basse
            highFrequency: 3000   // Fréquence de coupure haute
        });

        // Entrée/sortie
        this.input = this.eq;
        this.output = this.eq;

        // Valeurs par défaut
        this._low = 0;
        this._mid = 0;
        this._high = 0;
        this._lowFreq = 250;
        this._highFreq = 3000;
    }

    // === Getters ===
    get low() { return this._low; }
    get mid() { return this._mid; }
    get high() { return this._high; }
    get lowFrequency() { return this._lowFreq; }
    get highFrequency() { return this._highFreq; }

    // === Setters ===
    setLow(db) {
        this._low = db;
        this.eq.low.value = db;
    }

    setMid(db) {
        this._mid = db;
        this.eq.mid.value = db;
    }

    setHigh(db) {
        this._high = db;
        this.eq.high.value = db;
    }

    setLowFrequency(freq) {
        this._lowFreq = freq;
        this.eq.lowFrequency.value = freq;
    }

    setHighFrequency(freq) {
        this._highFreq = freq;
        this.eq.highFrequency.value = freq;
    }

    /**
     * Connecte l'EQ à une destination
     */
    connect(destination) {
        this.output.connect(destination);
    }

    /**
     * Obtient les paramètres actuels
     */
    getParams() {
        return {
            low: this._low,
            mid: this._mid,
            high: this._high,
            lowFrequency: this._lowFreq,
            highFrequency: this._highFreq
        };
    }

    /**
     * Applique des paramètres
     */
    setParams(params) {
        if (params.low !== undefined) this.setLow(params.low);
        if (params.mid !== undefined) this.setMid(params.mid);
        if (params.high !== undefined) this.setHigh(params.high);
        if (params.lowFrequency !== undefined) this.setLowFrequency(params.lowFrequency);
        if (params.highFrequency !== undefined) this.setHighFrequency(params.highFrequency);
    }

    dispose() {
        this.eq.dispose();
    }
}
